import React from "react";
import { FaCheckCircle } from "react-icons/fa"; // Using check circle icon
import { useTranslation } from "react-i18next";
import "./AboutPolicySection.css";

export default function PolicySection() {
  const { t } = useTranslation();

  // Fetch policies from translation file
  const policies = [
    t("policy_1"),
    t("policy_2"),
    t("policy_3"),
    t("policy_4"),
    t("policy_5"),
    t("policy_6"),
    t("policy_7"),
    t("policy_8"),
    t("policy_9")
  ];

  return (
    <section className="cm-policy-section-wrapper">
      <div className="cm-policy-section-container">
        <h2 className="cm-policy-section-title">{t("policy_main_title")}</h2>
        <p className="cm-policy-section-subtitle">{t("policy_subtitle")}</p>

        <div className="cm-policy-section-grid">
          {policies.map((item, index) => (
            <div key={index} className="cm-policy-section-card">
              <div className="cm-policy-icon">
                <FaCheckCircle />
              </div>
              <p className="cm-policy-section-card-text">{item}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
